<template>
    <div>
        <nav class="navbar is-spaced has-shadow" role="navigation">
            <div class="navbar-brand">
                <div class="navbar-item">
                    IMS
                </div>
                <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" v-bind:class="{'is-active': burgerActive}" v-on:click="burgerActive = !burgerActive">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
            </div>
            <div class="navbar-menu" v-bind:class="{'is-active': burgerActive}" v-on:click="burgerActive = !burgerActive">
                <div class="navbar-start">
                    <router-link to="/accountmanagement" class="navbar-item">Mein Account</router-link>
                </div>
                <div class="navbar-end">
                    <div class="navbar-item" @click="logout()"><a>Logout</a></div>
                </div>
            </div>
        </nav>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            burgerActive: false,
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('AUTH_LOGOUT').then(() => {
                this.$router.push({name: 'SignIn'});
            });
        }
    }
}
</script>

<style>

</style>
